var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRulesInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "information-dark-icon.e4c0d26e2e7444ad3e0d41e4c9d1eb6e",
    d: "M61.5,56A5.5,5.5,0,1,0,67,61.5,5.5,5.5,0,0,0,61.5,56Zm0,2.255a.715.715,0,1,1-.715.715A.715.715,0,0,1,61.5,58.255Zm1.32,6.215H60.4a.44.44,0,0,1,0-.88h.77V61.17h-.44a.44.44,0,1,1,0-.88h.88a.44.44,0,0,1,.44.44v2.86h.77a.44.44,0,1,1,0,.88Z",
    transform: "translate(-56 -56)",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesInfoIcon);
export default __webpack_public_path__ + "static/media/rules-info-icon.9b4f2e01b1467a28c727d6dcb443fca7.svg";
export { ForwardRef as ReactComponent };